import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#2c3e50",
                accent: "#c87600"
            },
            dark: {
                primary: "#ffffff",
                accent: "#dc8100"
            }
        }
    }
});
